import { defineMessages } from 'react-intl';

const translations = {
  breadcrumbs: {
    batches: {
      id: 'viewBatch.breadcrumbs.batches',
      defaultMessage: 'Batches',
      description: 'Label of the breadcrumb batches',
    },
  },
  subNavigation: {
    details: {
      id: 'viewBatch.subNavigation.details',
      defaultMessage: 'Details',
      description: 'Label of the sub navigation details',
    },
    communication: {
      id: 'viewBatch.subNavigation.communication',
      defaultMessage: 'Communication',
      description: 'Label of the sub navigation communication',
    },
  },
  secondaryActions: {
    validate: {
      id: 'viewBatch.secondaryActions.validate',
      defaultMessage: 'Validate',
      description: 'Label of the secondary action validate',
    },
    confirm: {
      id: 'viewBatch.secondaryActions.confirm',
      defaultMessage: 'Confirm',
      description: 'Label of the secondary action confirm',
    },
  },
  validateProgressDialog: {
    message: {
      id: 'viewBatch.validateProgressDialog.message',
      defaultMessage: 'Validating batch',
      description: 'Message of the validate batch progress dialog',
    },
  },
  feedback: {
    batchValidationSucceeded: {
      id: 'viewBatch.feedback.batchValidationSucceeded',
      defaultMessage: 'The batch validation has succeeded',
      description: 'Success message of the batch start batch validation action',
    },
    batchValidationFailed: {
      id: 'viewBatch.feedback.batchValidationFailed',
      defaultMessage: 'The batch validation failed',
      description: 'Error message of the batch start batch validation action',
    },
    batchConfirmed: {
      id: 'viewBatch.feedback.batchConfirmed',
      defaultMessage: 'The batch has been confirmed',
      description: 'Success message of the batch confirm action',
    },
    batchNotConfirmed: {
      id: 'viewBatch.feedback.batchNotConfirmed',
      defaultMessage: 'The batch could not be confirmed',
      description: 'Error message of the batch confirm action',
    },
  },
};

export default defineMessages(translations);
